import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import messages from './locales'
import '@fortawesome/fontawesome-free/css/all.css'

// 添加错误处理
try {
    const i18n = createI18n({
        legacy: false,
        locale: 'zh',
        fallbackLocale: 'zh',
        messages,
        silentTranslationWarn: true,
        missingWarn: false,
        fallbackWarn: false,
        warnHtmlMessage: false
    })

    const app = createApp(App)
    app.use(i18n)
    app.use(router)
    app.mount('#app')
} catch (error) {
    console.error('I18n initialization error:', error)
}
